import { Purchases } from '@revenuecat/purchases-js';

const normalizeBaseUrl = (value?: string): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  return trimmed.replace(/\/?$/, '');
};

export const getCheckoutBaseUrl = (): string | null => normalizeBaseUrl(import.meta.env.RC_WEB_PURCHASE_LINK);

export const buildCheckoutUrl = (billingId?: string | null): string | null => {
  if (!billingId) {
    return null;
  }

  const checkoutBaseUrl = getCheckoutBaseUrl();
  if (!checkoutBaseUrl) {
    return null;
  }

  return `${checkoutBaseUrl}/${billingId}`;
};

export const ensureRevenueCatConfigured = async (apiKey: string, appUserId: string): Promise<Purchases> => {
  if (!apiKey) {
    throw new Error('RevenueCat API key is not configured.');
  }

  const purchases = Purchases.configure({ apiKey, appUserId });
  return purchases;
};

export const getRevenueCatManagementUrl = async (apiKey: string, appUserID: string): Promise<string | null> => {
  const purchases = await ensureRevenueCatConfigured(apiKey, appUserID);
  const customerInfo = await purchases.getCustomerInfo();
  return customerInfo?.managementURL ?? null;
};
